import { Navigate } from "react-router-dom";
import useSupportSessionGuard from "../hooks/useSupportSessionGuard";

export default function SupportProtectedRoute({ children }) {
  const { checking, supportUser } = useSupportSessionGuard();

  if (checking) {
    return <div className="min-h-screen bg-[#171717]" />;
  }

  if (!supportUser?.id) {
    return <Navigate to="/u/support/login" replace />;
  }

  return children;
}
